export default "__VITE_ASSET__Cdl1aeSr__"